import { isZeroDecimalCurrency } from '@change-corgi/core/intl';

const DECIMAL_AMOUNT_PATTERN = /^\d+(\.\d+)?$/;

function roundToCurrencyDigits(amount: number, currency: string): number {
	const { maximumFractionDigits = 2 } = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency,
	}).resolvedOptions();
	const scale = 10 ** Math.min(maximumFractionDigits, isZeroDecimalCurrency(currency) ? 0 : 2);
	return Math.round(amount * scale) / scale;
}

export function getComboChipInAmount(
	amountParam: string | undefined,
	currency: string | undefined,
	pageCurrency: string,
): number | undefined {
	if (currency !== pageCurrency || !amountParam || !DECIMAL_AMOUNT_PATTERN.test(amountParam)) return undefined;
	const amount = roundToCurrencyDigits(Number(amountParam), pageCurrency);
	return Number.isFinite(amount) && amount > 0 ? amount : undefined;
}
